import React from 'react'
import { Breadcrumbs, MetaSeo } from '../..'
import { Trans } from '../../atoms'
import NewsCard from '../../molecules/NewsCard/NewsCard'

const NewsTemplate = (props) => {
  const news = props.news.map((obj) => {
    return <NewsCard news={obj} />
  })
  return (
    <div className="page">
      <div className="w-container news-main-container">
        <MetaSeo seo={props.page.seo} />
        <Breadcrumbs breadcrumbs={props.page.breadcrumbs} />
        <h1>News</h1>
        <br />
        <h2>
          <Trans chiave="Rimani aggiornato sulle ultime novita del mondo Sipec." />
        </h2>
        <br />
        <div className="news-card-container">{news}</div>
      </div>
    </div>
  )
}

export default NewsTemplate
